import { render, staticRenderFns } from "./BaseTeacherTable.vue?vue&type=template&id=2786fdef&scoped=true"
import script from "./BaseTeacherTable.vue?vue&type=script&lang=js"
export * from "./BaseTeacherTable.vue?vue&type=script&lang=js"
import style0 from "./BaseTeacherTable.vue?vue&type=style&index=0&id=2786fdef&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2786fdef",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/al-khaleej/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2786fdef')) {
      api.createRecord('2786fdef', component.options)
    } else {
      api.reload('2786fdef', component.options)
    }
    module.hot.accept("./BaseTeacherTable.vue?vue&type=template&id=2786fdef&scoped=true", function () {
      api.rerender('2786fdef', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/global/v2/BaseTeacherTable.vue"
export default component.exports